module.exports = __webpack_public_path__ + "static/img/speed-start-s.60420f57.png";